import PropTypes from 'prop-types';
import React from 'react';
import range from 'lodash/range';
import SelectWithIndeterminate from './SelectWithIndeterminate';

const getDropdownOptions = (fromValue, toValue, type, increment = 1, suffix = '') =>
  range(fromValue, toValue, increment)
    .map(number => ({
      value: number,
      label: `${number}${suffix}`,
    }));

const getOptions = (customOptions, fromValue, toValue, type, increment = 1, suffix = '') => [
  { value: null, label: ' ' },
  ...getDropdownOptions(fromValue, toValue, type, increment, suffix),
  ...customOptions,
];

const RangeSelect = ({ name, start, end, increment, valueSuffix, customOption, ...props }) => (
  <SelectWithIndeterminate
    name={name}
    options={getOptions(customOption, start, end, name, increment, valueSuffix)}
    {...props}
  />
);

RangeSelect.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  increment: PropTypes.number,
  customOption: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string,
  })),
  valueSuffix: PropTypes.string,
};
RangeSelect.defaultProps = {
  className: '',
  increment: 1,
  customOption: [],
  valueSuffix: '',
};

export default RangeSelect;
